import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";
import UseGraph from "../utils/useGraph";
import formQueryUrl from "../utils/formQueryUrl";

const noData = [{ name: "Empty", value: 1, color: "var(--color-bg-overlay-mid)" }];

const data = [
  { name: "Cancelled", value: 0, color: "#4F46E5" },
  { name: "Rebroked", value: 0, color: "#818CF8" },
  { name: "Mismatched", value: 0, color: "#C7D2FE" },
];

const PieChartComponent = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [widgetCount, setWidgetCount] = useState<Record<string, any>[]>(data)
  const { startDate, endDate } = UseGraph()


  useEffect(() => {
    const findStatsData = async () => {
      setLoading(true)
      try {
        const filtersArray = [startDate !== null && { startDate }, endDate !== null && { endDate }]
        const widgetData = await axiosInstance.get(`/stats/chase/breakdown/counts${formQueryUrl(filtersArray, '?')}`)
        setWidgetCount((prev) => [...prev.map((widgetPrevItem) => ({ ...widgetPrevItem, value: Number(widgetData.data.find((widgetDataItem) => widgetDataItem?.status === widgetPrevItem?.name)?.value) || 0 }))])
        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    }

    findStatsData()
  }, [startDate, endDate])


  if (loading) {
    return <div className="animate-pulse h-full min-h-[420px] bg-surface border border-edge rounded-2xl" />
  }

  const total = widgetCount.reduce((sum, item) => sum + (Number(item?.value) || 0), 0);
  const hasData = total > 0;

  return (
    <div className="rounded-2xl h-full flex flex-col bg-surface border border-edge shadow-card px-6 py-5 animate-fade-in smallTablet:px-4 smallTablet:min-w-0">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-[16px] font-bold text-text-primary">Chase Breakdown</h1>
          <p className="mt-0.5 text-[13px] font-medium text-light-gray">By status</p>
        </div>
        <div className="text-right">
          <p className="text-[22px] font-bold text-text-primary tracking-tight leading-7 tabular-nums">
            {new Intl.NumberFormat("en-GB").format(total)}
          </p>
          <p className="text-[12px] font-medium text-light-gray">chases</p>
        </div>
      </div>

      <div className="relative flex-1 min-h-[160px] mt-2">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={hasData ? widgetCount : noData}
              cx="50%"
              cy="50%"
              innerRadius="66%"
              outerRadius="92%"
              paddingAngle={hasData ? 2 : 0}
              cornerRadius={6}
              dataKey="value"
              stroke="none"
              labelLine={false}
            >
              {(hasData ? widgetCount : noData).map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>

        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <p className="text-[24px] font-bold text-text-primary tracking-tight leading-7">
            {new Intl.NumberFormat("en-GB").format(total)}
          </p>
          <p className="text-[12px] font-medium text-light-gray">actioned</p>
        </div>
      </div>

      <div className="flex flex-col gap-3 mt-4">
        {widgetCount.map((status, index) => {
          const share = total > 0 ? Math.round((Number(status.value) / total) * 100) : 0;

          return (
            <div key={index} className="flex items-center gap-3">
              <span
                className="w-2 h-2 rounded-full shrink-0"
                style={{ backgroundColor: status.color }}
              />
              <p className="text-[13px] font-medium text-text-primary w-[86px] shrink-0">
                {status.name}
              </p>
              <div className="flex-1 h-1 rounded-full bg-overlay-mid overflow-hidden">
                <div
                  className="h-full rounded-full transition-[width] duration-700 ease-out"
                  style={{ width: `${share}%`, backgroundColor: status.color }}
                />
              </div>
              <p className="text-[14px] font-bold text-text-primary tabular-nums w-9 text-right">
                {status.value}
              </p>
              <p className="text-[12px] font-medium text-light-gray tabular-nums w-8 text-right">{share}%</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PieChartComponent;
